import React from "react";
import checkGif from "../assets/images/check.gif";

const SuccessfullSubmit = ({ title, subtitle }) => {
  return (
    <>
      <div className="flex flex-col items-center text-center">
        <img src={checkGif} alt="" width={194} height={194} />
        <h2 className="text-[24px] text-secondary font-bold mb-3 mt-4">
          {title}
        </h2>
        <p className="text-secondary font-semibold text-sm px-2 text-center mb-6">
          {subtitle}
        </p>
      </div>
    </>
  );
};

export default SuccessfullSubmit;
